import type { Theme, Components } from '@mui/material/styles';

import { CbridgePalette } from './theme.constant';

declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    trading: true;
  }
}

export const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body2,
      borderRadius: theme.spacing(1),
      padding: theme.spacing(0.25, 0.5),
      height: theme.spacing(3),
    }),
  },
  variants: [
    {
      props: { variant: 'outlined', color: 'primary' },
      style: () => ({
        color: CbridgePalette.text.primary,
        borderColor: CbridgePalette.text.disabled,
      }),
    },
    {
      props: { variant: 'outlined', color: 'error' },
      style: () => ({
        color: CbridgePalette.error.main,
        borderColor: CbridgePalette.error.main,
      }),
    },

    {
      props: { variant: 'filled', color: 'primary' },
      style: () => ({
        color: CbridgePalette.text.primary,
        background: CbridgePalette.button.secondary.main,
      }),
    },

    {
      props: { variant: 'filled', color: 'default' },
      style: () => ({
        color: CbridgePalette.text.primary,
        background: CbridgePalette.button.secondary.main,
      }),
    },

    {
      props: { variant: 'filled', color: 'secondary' },
      style: ({ theme }) => ({
        color: theme.palette.secondary.main,
        background: `color-mix(in srgb, ${theme.palette.secondary.main} 10%, transparent)`,
      }),
    },

    {
      props: { variant: 'filled', color: 'error' },
      style: () => ({
        color: CbridgePalette.error.main,
        background: `color-mix(in srgb, ${CbridgePalette.badge.error} 10%, transparent)`,
      }),
    },

    {
      props: { variant: 'filled', color: 'success' },
      style: ({ theme }) => ({
        color: theme.palette.success.main,
        background: `color-mix(in srgb, ${theme.palette.success.main} 10%, transparent)`,
      }),
    },

    {
      props: { variant: 'filled', color: 'warning' },
      style: ({ theme }) => ({
        color: theme.palette.warning.main,
        background: `color-mix(in srgb, ${theme.palette.warning.main} 10%, transparent)`,
      }),
    },

    {
      props: { variant: 'filled', color: 'info' },
      style: ({ theme }) => ({
        color: theme.palette.info.main,
        background: `color-mix(in srgb, ${theme.palette.info.main} 15%, transparent)`,
      }),
    },

    {
      props: { variant: 'filled', color: 'trading' },
      style: ({ theme }) => ({
        color: theme.palette.success.main,
        background: `color-mix(in srgb, ${CbridgePalette.chip.trading} 15%, transparent)`,
      }),
    },
  ],
};
